import type { GiftPassSourceFilter, GiftPassStatusFilter } from '../../api/gift-passes';
import { SearchInput } from '../dashboards/primitives/SearchInput';
import { GiftCardsFilterSelect } from '../gift-cards/GiftCardsFilterSelect';

import {
  GIFT_PASS_SOURCE_OPTIONS,
  GIFT_PASS_STATUS_OPTIONS,
  giftPassCountLabel,
  isGiftPassFiltered,
} from './gift-passes-model';

export interface GiftPassesListToolbarProps {
  searchInput: string;
  onSearchInputChange: (v: string) => void;
  status: GiftPassStatusFilter;
  onStatusChange: (v: GiftPassStatusFilter) => void;
  source: GiftPassSourceFilter;
  onSourceChange: (v: GiftPassSourceFilter) => void;
  onClear: () => void;
  total: number;
}

export function GiftPassesListToolbar(props: GiftPassesListToolbarProps) {
  const { searchInput, status, source } = props;
  const filtered = isGiftPassFiltered({ search: searchInput, status, source });
  return (
    <div
      style={{
        flex: '0 0 auto',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '10px 14px',
        borderBottom: '1px solid var(--nb-border)',
        flexWrap: 'wrap',
      }}
    >
      <SearchInput
        value={searchInput}
        onChange={props.onSearchInputChange}
        placeholder="Search purchaser, recipient, code, or booking…"
        ariaLabel="Search gift passes by email, name, code, order, or booking"
        style={{ width: 280, flex: '0 0 auto' }}
      />
      <GiftCardsFilterSelect
        label="Status"
        value={status}
        options={GIFT_PASS_STATUS_OPTIONS}
        onChange={props.onStatusChange}
      />
      <GiftCardsFilterSelect
        label="Origin"
        value={source}
        options={GIFT_PASS_SOURCE_OPTIONS}
        onChange={props.onSourceChange}
      />
      {filtered && (
        <button
          type="button"
          className="nb-btn nb-btn-ghost"
          style={{ height: 28 }}
          onClick={props.onClear}
        >
          Clear
        </button>
      )}
      <span style={{ flex: 1 }} />
      <span style={{ fontSize: 12, color: 'var(--nb-subtle)' }}>
        {giftPassCountLabel(props.total)}
      </span>
    </div>
  );
}
